import * as React from "react";
import { newImageCrop } from "../../helpers/newImageCrop";
import ImageFetch from "../../helpers/imageFetch";
import { imageWrapper } from "components/TicketImage/styles";
import { EventImages } from "types";

interface IProps {
  image: string;
  image_crop: {
    height: number;
    width: number;
    x: number;
    y: number;
  } | null;
  images: EventImages | null;
  className?: string;
  alt?: string;
}

const TicketImage = (props: IProps) => {
  let newCrop;
  if (props.images) {
    const c = props.images.crop1x1;
    newCrop = { url: c.url, x: c.x, y: c.y, height: c.height, width: c.width };
  } else {
    newCrop = newImageCrop(props.image, props.image_crop);
  }
  return (
    <React.Fragment>
      <ImageFetch
        alt={props.alt}
        className={imageWrapper}
        crop={newCrop}
        queries={[]}
        default={{ width: 96, ar: "Square" }}
        forceCrop={true}
      />
    </React.Fragment>
  );
};

export default TicketImage;
